import '../../utils/fix.cross-origin'
import LoadingMgr from './modal-manager';
/**
 * @createdBy:HuangJian
 * @date:2018/12/5
 * @params：
 * @description：
 * 注意事项：
 *  1 、动画采用请求计数的模式,即每调用一次 start,需要相应地调用一次 finish;
 *      若调用了两次 start，然后再调用一次 finish，这时动画不会消失
 *  2、若要强制关闭动画，可调用 close
 */
function getLoadingService() {
    if(!window.CURRENT_ORIGIN_TOP.window.$loadingSerivce){
        window.CURRENT_ORIGIN_TOP.window.$loadingSerivce = LoadingMgr.createService();
    }
    return window.CURRENT_ORIGIN_TOP.window.$loadingSerivce;
}


function start(message) {
    const loadingSerivce = getLoadingService();
    return loadingSerivce.open(message);
}
function finish(index) {
    const loadingSerivce = getLoadingService();
    return loadingSerivce.hide(index);
}
function close() {
    const loadingSerivce = getLoadingService();
    return loadingSerivce.close();
}
const module = {start, finish, close};
export default {
    start,
    finish,
    close,
    install(vue){
        vue.prototype.$lnkLoading = module;
    }
};
